import React from 'react';
//@ts-ignore
import * as logoStyle from '../../styles/logo.module.scss'
import { SVGProps } from "../../utils/typings";

export const ReactLogo: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            viewBox="175.7 78 490.6 436.9"
            xmlns="http://www.w3.org/2000/svg">
            <g fill="#61dafb">
                <path d="M666 297c0-33-40-64-103-83 15-64 8-114-20-130-7-4-14-6-22-6v22c4 0 8 1 11 3 14 8 19 37 15 76l-5 29c-20-5-41-8-64-11-13-18-27-35-41-50 32-30 63-47 84-47V78c-28 0-64 20-100 54-37-34-73-54-100-54v23c21 0 51 16 84 46-14 15-28 32-41 50-23 3-44 6-64 11l-5-29c-5-38 1-68 14-76l12-2V78c-9 1-16 2-23 6-28 16-34 67-20 130-62 19-102 50-102 82 0 33 40 64 103 83-15 63-8 114 20 130 6 4 14 6 22 6 28 0 64-20 100-54 37 34 73 53 100 53 9 1 16-1 23-5 28-16 34-67 20-130 62-19 102-50 102-83zm-130-67l-13 39a473 473 0 00-28-47l41 8zm-46 106l-24 39a520 520 0 01-90 0 551 551 0 01-45-78 521 521 0 0145-78 520 520 0 0190 0 551 551 0 0145 77c-6 14-13 27-21 40zm33-13c5 14 10 27 13 40l-41 8a552 552 0 0028-48zM421 430l-28-32a619 619 0 0056 0c-9 12-19 22-28 32zm-74-59l-41-8c3-13 8-26 13-39a473 473 0 0028 47zm74-208l27 32a619 619 0 00-55 0c9-12 18-22 28-32zm-74 59a552 552 0 00-28 48l-14-40 42-8zm-91 125c-35-15-58-35-58-50s23-36 58-51l28-10c6 19 13 40 22 61-9 20-16 41-22 60l-28-10zm54 143c-14-8-20-37-15-76l5-29c20 5 41 8 64 11 13 18 27 35 41 50-32 30-63 47-84 47-4 0-8-1-11-3zm237-76c5 38-1 68-14 76l-12 2c-21 0-51-16-84-46 14-15 28-32 41-50 23-3 44-6 64-11l5 29zm39-67l-28 10c-6-19-13-40-23-61 10-20 17-41 23-60l28 10c35 15 58 35 58 51 0 15-23 35-58 50z" />
                <circle cx="420.9" cy="296.5" r="45.7" />
            </g>
        </svg>
    )
}

export const NodeJSLogo: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            viewBox="-10 0 256 282"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMinYMin meet">
            <g fill="#8CC84B">
                <path d="M116.5 3.6c7-4 16-4 23 0l105 59.3c6.6 3.7 11 11 10.9 18.6v119c0 7.9-4.8 15.4-11.7 19-35 19.6-69.8 39.3-104.7 59-7 4-16.3 3.8-23.2-.6l-31.4-18.2c-2.1-1.3-4.5-2.3-6-4.4 1.3-1.8 3.7-2 5.6-2.8 4.4-1.3 8.4-3.6 12.4-5.7 1-.7 2.3-.5 3.2.2 9 5 17.8 10.4 26.8 15.4 2 1.1 3.9-.3 5.5-1.2l102.7-58c1.3-.6 2-2 1.9-3.4V82.1c.1-1.6-.8-3-2.2-3.7L130 19.7a3.6 3.6 0 00-4 0L21.7 78.5c-1.4.6-2.4 2-2.2 3.6V200a3.3 3.3 0 001.9 3.3l27.8 15.7c5.3 2.8 11.7 4.5 17.4 2.3 5.1-1.8 8.7-7 8.6-12.4v-117c-.1-1.8 1.5-3.2 3.2-3h13.4c1.9 0 3.1 1.8 3 3.5l-.1 117.8c0 10.5-4.3 21.9-14 27a43 43 0 01-38.4-1c-10.2-5.2-20-11.2-30-16.6a21.8 21.8 0 01-11.7-19v-119c0-7.7 4.5-15.2 11.3-18.9l104.6-59z" />
                <path d="M147 86c15.1-1 31.4-.6 45.1 6.9a34.2 34.2 0 0116.7 29.6c-.3 1.6-2 2.4-3.5 2.3H192c-2 0-3-1.7-3.2-3.3a20.2 20.2 0 00-9.7-14c-8.1-4-17.6-3.8-26.4-3.7a36 36 0 00-19 4.7c-4.2 2.9-5.5 8.7-4 13.4 1.5 3.4 5.3 4.4 8.5 5.4 18.4 4.8 37.8 4.4 55.8 10.7 7.4 2.5 14.7 7.5 17.2 15.3 3.4 10.5 2 23-5.5 31.4a43.9 43.9 0 01-23.6 12.7 113.2 113.2 0 01-35.5 1.5 56 56 0 01-31.3-11.8 32.8 32.8 0 01-10.6-25.9c0-1.6 1.7-2.7 3.3-2.6h13.3c1.8-.1 3 1.4 3.2 3 .8 5.4 2.8 11 7.5 14.3 9 5.8 20.3 5.4 30.7 5.5 8.6-.3 18.2-.4 25.2-6.1 3.7-3.2 4.7-8.6 3.8-13.3-1.1-4-5.2-5.7-8.8-7-18-5.7-37.7-3.6-55.6-10-7.3-2.6-14.3-7.5-17.1-15a30.5 30.5 0 016-31.7C124.4 90.2 136 87 147 86z" />
            </g>
        </svg>
    )
}

export const WebpackJSLogo: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            viewBox="-25 0 206 296"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMinYMin meet">
            <defs>
                <radialGradient fx="50%" fy="50%" id="a">
                    <stop stopColor="#93B4E7" offset="0%" />
                    <stop stopColor="#B9D1F8" offset="59.3%" />
                    <stop stopColor="#9CB6E0" offset="100%" />
                </radialGradient>
            </defs>
            <path d="M128 .5L.3 74.2v147.5L128 295.4l127.8-73.7V74.2L128 .5z" fill="url(#a)" />
            <path d="M128 75.3l-63.3 36.5V185l63.3 36.6 63.4-36.6v-73.2L128 75.3z" fill="#6F95DB" />
            <path d="M128 0L0 74.3l128 69.6 128-69.2L128 0zm0 153.5L0 221.4l128 73.8 127.5-74.3L128 153.5z" fill="#FFF" fillOpacity=".1" />
        </svg>
    )
}

export const TypescriptLogo: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 400 400">
            <path d="M0 200V0h400v400H0" fill="#007acc" />
            <path d="M87.7 200.7V217h52v148h36.9V217h52v-16c0-9 0-16.3-.4-16.5 0-.3-31.7-.4-70.2-.4l-70 .3v16.4l-.3-.1zM321.4 184c10.2 2.4 18 7 25 14.3a63 63 0 019.6 12.8c0 .6-17.3 12.3-27.8 18.8-.4.3-2-1.4-3.6-4-5.2-7.4-10.5-10.6-18.8-11.2-12-.8-20 5.5-20 16 0 3.2.6 5 1.8 7.6 2.7 5.5 7.7 8.8 23.2 15.6 28.6 12.3 41 20.4 48.5 32a58.3 58.3 0 014.7 48.7c-6.4 16.7-22 28-44.3 31.7-7 1.2-23 1-30.5-.3-16-3-31.3-11-40.7-21.3a71.5 71.5 0 01-10.4-15.4l3.8-2.4 15-8.7 11.3-6.6 2.6 3.5a54.4 54.4 0 0015 14.6c13 6.7 30.4 5.8 39-2a15 15 0 005.3-12c0-4.6-.7-6.7-3-10.2-3.2-4.4-9.6-8-27.6-16-20.7-8.8-29.5-14.4-37.7-23-4.7-5.2-9-13.3-11-20-1.5-5.8-2-20-.6-25.7 4.3-20 19.4-34 41-38a97 97 0 0130.4 1l-.2.2z" fill="#fff" />
        </svg>
    )
}

export const GitLogo: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            data-name="Capa 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1040.4 1040.4">
            <path d="M1020.8 473.9L566.5 19.6a67 67 0 00-94.7 0L377.4 114l119.7 119.6a79.6 79.6 0 01100.8 101.5l115.3 115.3A79.7 79.7 0 01795.6 582a79.7 79.7 0 01-130.1-86.7L557.9 387.8v283a80.7 80.7 0 0121.1 15 79.7 79.7 0 010 112.8 79.7 79.7 0 11-86.7-130.1V382.8a78.8 78.8 0 01-26-17.4 79.7 79.7 0 01-17.2-87.1l-118-118L19.6 471.7a67 67 0 000 94.8L474 1020.8a67 67 0 0094.8 0l452-452.1a67 67 0 000-94.8" fill="#de4c36" />
        </svg>
    )
}